import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import * as api from '../../services/roles/api_roles';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as sectionTableActions from '../../components/common/form/SectionTable/actions';
import { getErrorMessage } from '../../utils';

export function* fetchListRolesSaga(feathersApp) {
  yield takeLatest('FETCH_LIST_ROLES', callListRoles, feathersApp);
}

function* callListRoles(feathersApp, action) {
  const { filters, silent } = action;
  yield common.showProgressListTable(silent);
  try {
    const dataParams = {
      filters,
      list_type: 'role'
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

export function* deleteRolesFromListSaga(feathersApp) {
  yield takeEvery('DELETE_ROLES_FROM_LIST', callDeleteRolesFromList, feathersApp);
}

function* callDeleteRolesFromList(feathersApp, action) {
  yield deleteRoles(feathersApp, action);
  yield callListRoles(feathersApp, { silent: true });
}

function* deleteRoles(feathersApp, action) {
  yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  try {
    const { id } = action;
    let result = null;
    if (id) {
      const state = yield select();
      const { tenant, user } = state;
      const { id } = action;
      const params = { tenant, user, id };
      result = yield call(api.deleteRoles, feathersApp, params);
    }
    yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.ROLES } });
    return result;
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error })
  }
}


export function* deleteRolesSaga(feathersApp) {
  yield takeEvery('DELETE_ROLES', callDeleteRoles, feathersApp);
}

function* callDeleteRoles(feathersApp, action) {
  const result = yield deleteRoles(feathersApp, action);
  yield delay(2000);
  if (result) {
    browserHistory.push('/admin/role');
  }
}

export function* fetchRolesForEditSaga(feathersApp) {
  yield takeEvery('FETCH_ROLES_FOR_EDIT', callFetchRolesForEdit, feathersApp);
}

function* callFetchRolesForEdit(feathersApp, action) {
  const { tenant, user } = yield select();
  const { id } = action;
  try {
    yield common.showProgressDataById();
    if (id) {
      const fetchParams = { tenant, user, id };
      const doc = yield call(api.fetchRolesForEdit, feathersApp, fetchParams);

      //set payment parameters
      // const employeesDataParams = {
      //   filters: { role: id },
      //   query_type: 'role_employee'
      // };
      const employeesDataParams = {
        filters: { role: id },
        doc_type: 'entity/employee'
      };
      //call api to get employees
      const employeeData = yield call(api.getEmployeesData, feathersApp, employeesDataParams);
      //then set employees
      doc.employees = employeeData && employeeData.data;



      yield call(common.doneDataById, doc);
    } else {
      const featureParams = { limit: 99 };
      let features = yield call(apiCommon.queryDocs, feathersApp, DocType.FEATURE, featureParams);
      features = (features.data || []).map(feature => {
        feature = Object.assign({ feature }, { permission: 'restricted' });
        return feature;
      });

      const initialValues = {
        available_from: new Date(),
        features,
        active: true,
        is_admin: true,
      };

      yield call(common.doneDataById, initialValues);
    }
  } catch (error) {
    yield common.showErrorDataById(error);
  }
}



export function* saveRolesSaga(feathersApp) {
  yield takeEvery("SAVE_ROLES", callSaveRoles, feathersApp);
}
function* callSaveRoles(feathersApp, action) {
  yield common.showProgressSaveRecord();
  const { tenant, user } = yield select();
  try {
    const result = yield call(api.saveRoles, feathersApp, {
      tenant,
      user,
      data: action.data
    });
    const id = result && result.id;
    yield callFetchRolesForEdit(feathersApp, { id, silent: true });
    browserHistory.push(`/admin/role/edit/${id}`);
    yield common.doneSaveRecord(result, 'Roles was saved');
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}

export function* getRoleEmployees(app) {
  yield takeEvery('GET_ROLE_EMPLOYEES', callGetRoleEmployees, app);
}
function* callGetRoleEmployees(app, action) {
  const { key, payload } = action;
  yield put(sectionTableActions.setSectionTableLoader(key, true));

  try {
    const { data, total, limit, skip } = yield call(apiCommon.getDocs, app, { 
      ...payload,
      filters: { 
        ...payload.filters,
      },
      list_type: 'entity/employee',
    });

    const meta = {
      total,
      limit,
      skip
    }

    yield put(sectionTableActions.setSectionTableData(key, { data, meta }));
  } catch (err) {
    yield put(sectionTableActions.setSectionTableError(key, true, getErrorMessage(err)));
  }
}
